import { createAction } from '@reduxjs/toolkit';

export interface StartBroadcastFromFormActionInterface {
    caption?: string;
    description?: string;
    accessLevel?: string;
}

export const startBroadcastFromFormAction =
    createAction<StartBroadcastFromFormActionInterface>('create-broadcast/start');
